import { Injectable, Input, EventEmitter } from '@angular/core';
import { BaseService } from './BaseService';
import { APIServiceConnector } from './APIServiceConnector';
import { MetaDataCache } from '../Models/CommonModels';
import * as enumModels from '../Models/EnumModels';
import { MasterDataRequest } from '../Models/RequestModels';
import { UIState, UserState, ModuleMultilingualLabels } from '../Models/UIModels';
import { AppSettings } from '../Library/AppSettings';
import { StaffBasicInfo } from '../Models/GlobalEntities';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { MasterDataService } from './MasterDataService';
import { PMSService } from './PMSService';
import { ComplainService } from './ComplainService';
import { AuthActionCodes } from '../Models/EnumModels';


@Injectable({
    providedIn: 'root',
})
export class ComplainSignalRService extends BaseService {
    private _hubConnection: HubConnection;
    connectionEstablished = new EventEmitter<Boolean>();

    public connectionIsEstablished = false;
    Complain_Updated = new EventEmitter<any>();
    Complain_Added = new EventEmitter<any>();

    LastSuccessfulDate_Add: Date = new Date();
    LastVersion: number;

    constructor(public apiService: APIServiceConnector, public masterService: MasterDataService, protected pmsService: PMSService) {
        super();

    }

    public Init(): void {
        this.BaseURL = AppSettings.URL_ComplainService;

        this.createConnection();
        this.registerOnServerEvents();
        this.startConnection();
    }

    private createConnection() {
        let objThis = this;

        this._hubConnection = new HubConnectionBuilder()
            .withUrl(this.BaseURL + 'KSHub?SessionId=' + objThis.masterService.apiService.getSessionCookie())
            .withAutomaticReconnect()
            .build();
    }

    private startConnection(): void {
        if (this._hubConnection == undefined || this._hubConnection == null) {
            this.createConnection();
        }

        this._hubConnection
            .start()
            .then(() => {
                this.connectionIsEstablished = true;
                //console.log('Hub connection started');
                this.connectionEstablished.emit(true);

            })
            .catch(err => {
                this.connectionIsEstablished = false;
                //console.log('Error while establishing connection, retrying...');
                if (!AppSettings.APP_DEBUG) {
                    window.setTimeout(() => { this.startConnection() }, 5000);
                }
            });
    }

    private registerOnServerEvents(): void {
        this._hubConnection.onclose(err => {
            this.connectionIsEstablished = false;
            this.connectionEstablished.emit(false);
            if (!AppSettings.APP_DEBUG) {
                window.setTimeout(() => { this.startConnection() }, 5000);
            }
        });


        this._hubConnection.on('Complain_Updated', (data: any) => {
            if (data == null)
                return;

            this.SetLastVersion(data.OLTPData);

            if (data.OLTPData.LoggedBy == this.masterService.LoggedInUserData.StaffId || this.masterService.CheckAuth_Dept_Action(data.OLTPData.PropertyId, data.OLTPData.DeptId, AuthActionCodes.CallConsoleView)) {
                this.Complain_Updated.emit(data);
            }
        });

        this._hubConnection.on('Complain_Added', (data: any) => {
            if (data == null)
                return;

            this.SetLastVersion(data);

            if (data.LoggedBy == this.masterService.LoggedInUserData.StaffId || this.masterService.CheckAuth_Dept_Action(data.PropertyId, data.DeptId, AuthActionCodes.CallConsoleView)) {
                this.Complain_Added.emit(data);
                this.LastSuccessfulDate_Add = new Date();
            }

        });

        this._hubConnection.on('Complain_UpdateFromLast', (data: any) => {
            //console.info(data);

            if (data == null)
                return;

            for (let i = 0; i < data.length; i++) {
                let row = data[i];
                let res: any = {};
                res.OLTPData = row;
                res.PrevOLTPData = row;
                res.Prev_AssignedTo_ComplainOLTP = null;

                let dt: Date = new Date(row.RegisteredAt);

                if (dt > this.LastSuccessfulDate_Add)
                    this.Complain_Added.emit(row);
                else
                    this.Complain_Updated.emit(res);

                this.SetLastVersion(row);
            }

            this.LastSuccessfulDate_Add = new Date();

        });

        this.connectionEstablished.subscribe(data => {
            //console.info("C = " + data);
            if (data == true)
                this.RegisterForProperties();
        });
    }

    private SetLastVersion(row: any): void {
        if (row == null)
            return;

        if (this.LastVersion == null)
            this.LastVersion = row.Version;
        else {
            if (row.Version > this.LastVersion)
                this.LastVersion = row.Version;
        }
    }

    private RegisterForProperties(): void {
        //console.info(this.masterService.GetPropertyIDs());
        let _version: number = this.LastVersion; // 192068093;

        this._hubConnection.invoke("RegisterForProperties", this.masterService.GetPropertyIDs(), _version).then(data => {
            //console.info("Complain signalR = " + data);
        });
    }
}
